import React from "react";

export default function UserData(props) {
  return (
    <div className="bg-white md:min-w-56 md:h-[750px] w-[100%] px-10 p-4 md:rounded-3xl overflow scrollbar-hidden">
      <div className="flex flex-col justify-evenly items-center h-fit pb-2 ">
        <span className="py-5"><img
          src={props.img}
          className="h-[120px] w-[120px]  rounded-full border-2 border-primary"
        ></img></span>
        <p className="text-primary font-bold pb-2">{props.name}</p>
        <p className="text-sm flex justify-center items-center"><p>{props.userId}</p></p>
        <p className="text-slate-600 font-bold pb-2">{props.role}</p>
        
        <p className=" text-center pb-2 min-w-48">{props.about}</p>
      </div>
      <div>
        <p className="text-lg font-semibold mb-1">Skills</p>
        <div className="flex flex-wrap justify-evenly items-center space-y-2 ">
          {props.skills.map((item, index) => (
            <div
              key={index}
              className="min-w-[60px] flex justify-center items-center h-[40px] px-2 py-1 bg-[#F1F1F1] mx-1 my-1 rounded-xl "
            >
              <p className="px-1.5 py-1 text-xs text-center ">{item}</p>
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
}
